import React, {useContext} from "react";
import { observer } from "mobx-react-lite";
import {Button, Card, CardBody, CardFooter, CardHeader, Col, Form, FormGroup, Row} from "reactstrap";
import { FormattedMessage } from "react-intl";
import {StateContext} from "../../../App";

const ViewFilePic = observer(({ store }) => {
  return (
    <>
      <Card>
        <CardBody>
             <img  src={store.fileImageUrl} alt={"fileImage"} style={{width:"500px"}}/>
        </CardBody>
        <CardFooter>
        </CardFooter>
      </Card>
    </>
  );
});

export default ViewFilePic;

